const appConfig = {
    apiUrl: "API_URL",
    recaptchaSiteKey: "RECAPTCHA_SITE_KEY"
}

export default appConfig;